/* Product-card image browser (prev/next chevrons) with a slide transition.
   Binds ALL `.tile-img-nav` buttons via event delegation on document, so it works on
   every grid that renders tile-product with show_image_nav_override (collection, search,
   homepage) and survives AJAX-rendered/filtered grids.

   The homepage `featured-collection-intro` keeps its own inline binding (so it also works
   in the theme editor, where this module isn't loaded). That inline handler calls
   stopPropagation(), so this delegated handler never double-fires on the homepage. */
(function () {
  function navigate(wrap, dir) {
    if (wrap.dataset.sliding === '1') return;
    var dataEl = wrap.querySelector('[data-tile-images]');
    var img = wrap.querySelector('.tile-media');
    if (!dataEl || !img) return;
    var imgs;
    try { imgs = JSON.parse(dataEl.textContent) || []; } catch (err) { return; }
    if (imgs.length < 2) return;

    var idx = parseInt(wrap.getAttribute('data-img-index') || '0', 10);
    idx = (((idx + dir) % imgs.length) + imgs.length) % imgs.length;
    wrap.setAttribute('data-img-index', String(idx));

    wrap.dataset.sliding = '1';

    var incoming = img.cloneNode(false);
    incoming.removeAttribute('srcset');
    incoming.removeAttribute('id');
    incoming.classList.add('tile-media--slide');
    img.classList.add('tile-media--slide');

    // Start positions (no transition yet)
    incoming.style.transition = 'none';
    img.style.transition = 'none';
    incoming.style.transform = 'translateX(' + (dir > 0 ? '100%' : '-100%') + ')';
    img.style.transform = 'translateX(0)';
    incoming.src = imgs[idx];
    wrap.appendChild(incoming);

    void wrap.offsetWidth; // reflow so the start position sticks

    var ease = 'transform 350ms cubic-bezier(0.4, 0, 0.2, 1)';
    incoming.style.transition = ease;
    img.style.transition = ease;
    incoming.style.transform = 'translateX(0)';
    img.style.transform = 'translateX(' + (dir > 0 ? '-100%' : '100%') + ')';

    var finished = false;
    function done() {
      if (finished) return;
      finished = true;
      if (img.parentNode) img.parentNode.removeChild(img);
      incoming.style.transition = '';
      incoming.style.transform = '';
      incoming.classList.remove('tile-media--slide');
      wrap.dataset.sliding = '';
    }
    incoming.addEventListener('transitionend', done);
    setTimeout(done, 450); // fallback
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.tile-img-nav');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var wrap = btn.closest('.tile-media-wrapper');
    if (!wrap) return;
    navigate(wrap, btn.classList.contains('tile-img-nav--next') ? 1 : -1);
  });
})();
